module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-09-be628b00aad00070c16f49f144f92b57.jpg";